// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"addaf96d","728":"510e5f02"}[chunkId] + ".chunk.js";
};